import { Roles } from './model';

export const navigation = [
  {
    title: true,
    name: 'Admin Portal'
  },

  {
    divider: true
  },

  {
    name: 'Job Management',
    url: '/home/job',
    icon: 'fa fa-tasks'
  },
  {
    name: 'PM Service Management',
    url: '/home/preventive-maintenance',
    icon: 'fa fa-wrench'
  },
  {
    name: 'E-Call Management',
    url: '/home/e-call',
    icon: 'icon-bell'
  },
  {
    name: 'Service Call Management',
    url: '/home/service',
    icon: 'fa fa-inbox'
  },
  {
    name: 'Work Schedule',
    url: '/home/schedule',
    icon: 'icon-calendar'
  },
  {
    name: 'Report',
    url: '/home/report',
    icon: 'icon-docs'
  },

  {
    divider: true
  },

  {
    name: 'Customer',
    url: '/home',
    icon: 'fa fa-address-book',
    children: [
      {
        name: 'Customer Management',
        url: '/home/customers',
        icon: 'fa fa-users'
      },
      {
        name: 'Site Management',
        url: '/home/site',
        icon: 'fa fa-sitemap'
      },
      {
        name: 'Equipment Management',
        url: '/home/equipment',
        icon: 'fa fa-gears'
      },
      {
        name: 'Contract Management',
        url: '/home/contract',
        icon: 'fa fa-book',
        role: [Roles.Admin],
      },
      {
        name: 'Survey Management',
        url: '/home/survey',
        icon: 'fa fa-file-text-o',
        role: [Roles.Admin],
      }
    ]
  },

  {
    divider: true
  },

  {
    title: true,
    name: 'Internal Management',
    role: [Roles.Admin],
  },
  {
    name: 'User',
    url: '/home/users',
    icon: 'icon-people',
    role: [Roles.Admin],
  },
  {
    name: 'Product Category',
    url: '/home/product-category',
    icon: 'fa fa-cubes',
    role: [Roles.Admin],
  }
];



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/_nav.ts